var React = require('react');

function IconEmail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.1381 0H1.85185C1.69169 0 1.62162 0.190955 1.73173 0.301508L9.56957 8.17085C9.80981 8.41206 10.2002 8.41206 10.4404 8.17085L18.2683 0.311558C18.3784 0.201005 18.2983 0 18.1381 0Z","fill":"#222222","key":0}),React.createElement("path",{"d":"M10.7107 10.7435C10.5105 10.9445 10.2603 11.035 10 11.035C9.73974 11.035 9.48949 10.9345 9.28929 10.7435L0.530531 1.93951C0.33033 1.7385 0 1.87921 0 2.16061V13.0048C0 13.5576 0.45045 14.0099 1.001 14.0099H18.999C19.5495 14.0099 20 13.5576 20 13.0048V2.06011C20 1.8189 19.7097 1.6983 19.5395 1.86916L10.7107 10.7435Z","fill":"#222222","key":1})]);
}

IconEmail.defaultProps = {"width":"20","height":"15","viewBox":"0 0 20 15","fill":"none"};

module.exports = IconEmail;

IconEmail.default = IconEmail;
